/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {
  useCallback,
  useState
} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  dialogControlSelector,
  editSelectedGridData,
  toggleDialog
} from './state';
import {DialogType, SelectedGridDataProps} from './types';

export interface UseDialogResult {
  show: boolean;
  open: Function;
  close: () => void;
  clearForm: boolean;
  selectedGridData: SelectedGridDataProps;
}

/**
 * Re-usable hook for managing the opening & closing of a dialog.
 */
export const useDialog = (dialog: DialogType): UseDialogResult => {
  const dispatch                  = useDispatch();
  const {show, selectedGridData}  = useSelector(state => dialogControlSelector(state, dialog));
  const [clearForm, setClearForm] = useState<boolean>(false);

  const close = useCallback(function(): void {
    dispatch(toggleDialog(false, dialog) as any);
    setClearForm(true);
  }, [dialog]);

  const open = useCallback(function(selectedData): void {
    dispatch(editSelectedGridData(dialog, selectedData));
    dispatch(toggleDialog(true, dialog) as any);
  }, [dialog]);
  
  return {
    show,
    close,
    open,
    clearForm,
    selectedGridData
  };
};
